import { Link } from "gatsby"
import * as React from "react"

export const ChooseUs = () => {
  return (
    <div className="container mx-auto">
      <div className="mt-10 pt-5">
        <h2 className="text-2xl text-center text-black">
          Why
          <span className="font-bold"> Client Choose Us!</span>
        </h2>
      </div>
      <div className="flex lg:flex-row flex-col mt-10 pt-20 justify-between">
        <div className="lg:w-1/3 px-5 lg:px-12 text-center">
          <div>
            <p className="text-black text-xl font-semibold py-2">
              We do all the work
            </p>
            <p className="text-gray text-sm">
              Branding, design, development, marketing, and SEO all in one
              place! We provide complete solutions to help your business grow
              and succeed effortlessly.
            </p>
          </div>
        </div>
        <div className="lg:w-1/3 px-5 lg:px-12 text-center">
          <div>
            <p className="text-black text-xl font-semibold py-2">
              The quality you deserve
            </p>
            <p className="text-gray text-sm">
              We are committed to providing top-notch solutions with precision,
              creativity, and efficiency. Expect nothing less than excellence in
              every project we handle!
            </p>
          </div>
        </div>
        <div className="lg:w-1/3 px-5 lg:px-12 text-center">
          <div>
            <p className="text-black text-xl font-semibold py-2">
              Latest Technology picked for you
            </p>
            <p className="text-gray text-sm">
              We harness the latest technologies to deliver innovative,
              high-performance solutions customized to meet your unique business
              needs. Stay ahead with the best!
            </p>
          </div>
        </div>
      </div>
      <div className="flex lg:flex-row flex-col lg:mt-14 lg:pt-20 justify-between">
        <div className="lg:w-1/3 px-5 lg:px-12 text-center">
          <div>
            <p className="text-black text-xl font-semibold py-2">
              One-time or ongoing
            </p>
            <p className="text-gray text-sm">
              Whether you need a one-time solution or ongoing support, we ensure
              timely execution and seamless service to keep your business
              running smoothly.
            </p>
          </div>
        </div>
        <div className="lg:w-1/3 px-5 lg:px-12 text-center">
          <div>
            <p className="text-black text-xl font-semibold py-2">
              Full speed and transparency
            </p>
            <p className="text-gray text-sm">
              We work with efficiency and openness, ensuring fast execution and
              clear communication at every step. Your success is our priority!
            </p>
          </div>
        </div>
        <div className="lg:w-1/3 px-5 lg:px-12 text-center">
          <div>
            <p className="text-black text-xl font-semibold py-2">
              Industry expertise
            </p>
            <p className="text-gray text-sm">
              With deep industry knowledge and proven experience, we deliver
              solutions tailored to your sector’s unique challenges and
              opportunities.
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-4 pt-5">
        <Link
          to="/real-time-quote"
          className="px-6 bg-button-unique book-free-consultancy-radius py-3 text-black font-inter lg:text-sm text-xs whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in rounded-lg bg-btn bg-glass"
        >
          Scope Your Project
        </Link>
      </div>
    </div>
  )
}
